import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import Svg, { Path } from 'react-native-svg';

interface TabSelectorProps {
  activeTab: 'board' | 'table';
  onTabChange: (tab: 'board' | 'table') => void;
}

const BoardIcon = ({ active }: { active: boolean }) => (
  <Svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <Path d="M16.6673 2.50082L4.16728 2.5039C3.25061 2.50413 2.5008 3.25431 2.50102 4.17098L2.5039 15.8376C2.50412 16.7543 3.25431 17.5041 4.17097 17.5039L16.671 17.5008C17.5876 17.5006 18.3375 16.7504 18.3372 15.8337L18.3344 4.16708C18.3341 3.25041 17.5839 2.50059 16.6673 2.50082ZM16.6677 4.16749L16.6683 6.66749L4.1683 6.67057L4.16769 4.17057L16.6677 4.16749ZM12.5039 15.8352L8.33723 15.8362L8.33538 8.33621L12.502 8.33518L12.5039 15.8352ZM4.16871 8.33723L6.66871 8.33662L6.67056 15.8366L4.17056 15.8372L4.16871 8.33723ZM14.1706 15.8348L14.1687 8.33477L16.6687 8.33415L16.6706 15.8342L14.1706 15.8348Z" fill="#2D2D2D" />
  </Svg>
);

const TableIcon = ({ active }: { active: boolean }) => (
  <Svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <Path d="M3.33435 4.17078L3.33702 15.0041L17.5037 15.0006L17.501 4.16729L3.33435 4.17078ZM11.6681 5.83539L11.6699 13.3354L9.16994 13.336L9.16809 5.83601L11.6681 5.83539ZM5.00143 5.83703L7.50143 5.83642L7.50328 13.3364L5.00328 13.337L5.00143 5.83703ZM15.8366 13.3344L13.3366 13.335L13.3348 5.83498L15.8348 5.83436L15.8366 13.3344Z" fill="#2D2D2D" />
  </Svg>
);

const TabSelector: React.FC<TabSelectorProps> = ({ activeTab, onTabChange }) => {
  return (
    <View style={styles.container}>
      <TouchableOpacity
        style={[styles.tab, activeTab === 'board' && styles.activeTab]}
        onPress={() => onTabChange('board')}
      >
        <BoardIcon active={activeTab === 'board'} />
        <Text style={[styles.tabText, activeTab === 'board' && styles.activeTabText]}>
          Board
        </Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={[styles.tab, activeTab === 'table' && styles.activeTab]}
        onPress={() => onTabChange('table')}
      >
        <TableIcon active={activeTab === 'table'} />
        <Text style={[styles.tabText, activeTab === 'table' && styles.activeTabText]}>
          Table
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    backgroundColor: '#EFF5FC',
    borderRadius: 6,
    // padding: 3,
  },
  tab: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingHorizontal: 16,
    paddingVertical: 6,
    borderRadius: 4,
    backgroundColor: 'transparent',
  },
  activeTab: {
    backgroundColor: '#FBFCFE',
    ...Platform.select({
      ios: {
        shadowColor: 'rgba(0, 0, 0, 0.08)',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 1,
        shadowRadius: 2,
      },
      android: {
        elevation: 1,
      },
      web: {
        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.08)',
      },
    }),
  },
  tabText: {
    fontSize: 14,
    fontWeight: '400',
    color: '#3A3A3A',
    fontFamily: Platform.OS === 'ios' ? 'System' : 'sans-serif',
  },
  activeTabText: {
    color: '#3A3A3A',
    fontWeight: '700',
  },
});

export default TabSelector;
